<template>
    <div id="calendar-index">
        <div id="calendar-clear-interventions" class="flex items-center mb-1.5">
            <md-button class="md-default md-icon-button md-raised" @click="clearSelectedInterventions"
                       :disabled="transferInterventions.length === 0">
                <font-awesome-icon class="md-icon" :icon="['fa', 'times-circle']" />
                <span class="leading-none ml-2 font-medium">
                    Déselectionner les interventions ({{ transferInterventions.length }})
                </span>
            </md-button>
        </div>
        <div class="md-layout md-gutter" v-for="week in calendarWeeks" :key="week.number">
            <div class="md-layout-item md-size-100">
                <md-card class="mt-0">
                    <div class="calendar" :id="'calendar-week-' + week.number">
                        <calendar-row-header :weekNumber="week.number" :days="week.days"
                            @toggle-extend-technicians="toggleExtendTechnicians($event)"></calendar-row-header>
                        <calendar-row-technician v-for="technician in week.technicians" :key="technician.id"
                                                 :technician="technician"
                                                 :weekNumber="week.number"
                                                 @update-cell="updateData($event)"
                                                 @clear-selected-intervention="clearSelectedInterventions">
                        </calendar-row-technician>
                    </div>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
import CalendarRowHeader from "@/pages/Planning/Calendar/components/calendar/CalendarRowHeader";
import CalendarRowTechnician from "@/pages/Planning/Calendar/components/calendar/CalendarRowTechnician";
import momentRangeMixin from '@/mixins/moment-range-mixin'

import { mapState } from "vuex";

export default {
    name: "CalendarView",
    components: { CalendarRowTechnician, CalendarRowHeader },
    mixins: [momentRangeMixin],
    props: {
        filters: {
            type: Object,
            default() {
                return {
                    technicians: [],
                    date: {
                        year: { number: this.$moment().year(), label: this.$moment().year() },
                        month: null
                    }
                }
            }
        }
    },
    data() {
        return {
            technicians: [],
            calendarWeeks: [],
            weeksToLoad: 0,
            loadedWeeks: 0,
            selectedInterventions: {
                from: '',
                technicianId: '',
                interventions: []
            },
        }
    },
    computed: {
        ...mapState({
            transferInterventions: state => state.calendarTransfer.interventions
        })
    },
    methods: {
        async getCalendarData() {
            this.$emit('updating')
            const { data } = await this.$store.dispatch('calendar/getCalendar', {
                filters: {
                    technicians: this.filters.technicians.map(technician => { return technician.id }),
                    year: this.filters.date.year.number,
                    month: this.filters.date.month.number,
                    loadedWeeks: this.loadedWeeks
                }
            })
            this.calendarWeeks.push(data)
            this.loadedWeeks++
            if(this.loadedWeeks < this.weeksToLoad) {
                await this.getCalendarData()
            }
            if(this.loadedWeeks === this.weeksToLoad) {
                this.$emit('loaded')
            }
        },
        weeksInCurrentMonth() {
            this.calendarWeeks = []
            this.loadedWeeks = 0
            this.weeksToLoad = 0

            const month = this.filters.date.month.number
            const year = this.filters.date.year.number

            this.weeksToLoad = this.weeksInMonth(year, month).length
            this.getCalendarData()
        },
        updateData(weeks) {
            weeks.map(week => {
                let weekToUpdate = this.calendarWeeks.find(cWeek => cWeek.number === week.number)
                if(weekToUpdate !== undefined) {
                    const updatedTechnician = week.technician
                    let technicianToUpdate = weekToUpdate.technicians.find(technician => technician.id === updatedTechnician.id)
                    if(technicianToUpdate) {
                        let dayToUpdate = technicianToUpdate.days.find(day => day.day === updatedTechnician.days[0].day)
                        // check if dayToUpdate is in the current week
                        if(dayToUpdate) {
                            dayToUpdate.plannings = updatedTechnician.days[0].plannings
                            dayToUpdate.absences = updatedTechnician.days[0].absences
                            dayToUpdate.isConflict = updatedTechnician.days[0].isConflict
                        }
                    }
                }
            })
        },
        clearSelectedInterventions() {
            this.$store.dispatch('calendarTransfer/clearInterventions')
        },
        toggleExtendTechnicians({ extended, weekNumber }) {
            let week = this.calendarWeeks.find(week => week.number === weekNumber)
            week.technicians.map(technician => { technician.extended = extended })
        },
    },
    mounted() {
        if(this.filters.date.year && this.filters.date.month) {
            this.weeksInCurrentMonth()
        }
    },
    created() {
        bus.$on('updated-panel', (data) => {
            this.updateData(data)
        })
    },
    watch: {
        filters: {
            deep: true,
            handler: function(newVal) {
                if(newVal.date.year && newVal.date.month) {
                    if(newVal.date.year !== this.filters.date.year || newVal.date.month !== this.filters.date.month) {
                        this.calendarWeeks = []
                    }
                    this.weeksInCurrentMonth()
                }
            },
        }
    }
}
</script>

<style scoped lang="scss">
.md-layout.md-gutter {
    margin: 0;
    &:first-child {
        margin-bottom: 10px;
    }
    .md-layout-item {
        padding: 0 10px;

        &:first-child {
            padding-left: 0;
        }

        &:last-child {
            padding-right: 0;
        }
    }
}
</style>
